import { Component } from '@angular/core';

@Component({
    selector: 'jobs',
    templateUrl: './jobs.component.html',
})
export class JobsComponent {}
